const handleButtonActive = (btn, target) => {
  let buttonlang = btn.find("span");
  if (target.hasClass("expand")) {
    if (buttonlang.text() == "Read less") {
      buttonlang.text("Read more");
    }
    if (buttonlang.text() == "Lire moins") {
      buttonlang.text("Lire plus");
    }
  } else {
    if (buttonlang.text() == "Read more") {
      buttonlang.text("Read less");
    }
    if (buttonlang.text() == "Lire plus") {
      buttonlang.text("Lire moins");
    }
  }
  target.toggleClass("expand");
}

const readMoreBoxButton = (btn, target) => {
  btn.on("click", (e) => {
    handleButtonActive(btn, target);
  });

  btn.keyup(e => {
    if (e.keyCode === 13) {
      handleButtonActive(btn, target);
    }
  });
}

const readMoreBox = () => {
  const target = $(".read-more-content");
  const btn = $(".read-more-content__button > span");

  if (target.data('auto')) {
    if (target.height() > 340) {
      target.addClass("active");
    }

    readMoreBoxButton(btn, target);
  } else if (target.data('use')) {
    target.addClass("active");
    readMoreBoxButton(btn, target);
  }
};

$(document).ready(() => {
  readMoreBox();
});